<template>
  <li class="nav-item" :class="{ active: showCollapse || automation }">
    <a
      v-if="!link.path"
      v-b-tooltip
      title=""
      @click="
        showCollapse = !showCollapse;
        $emit('click-menu');
      "
      class="nav-link"
      :target="link.target"
    >
      <template>
        <span class="ico-sidebar">
          <img
            width="22"
            class="menu-default"
            :src="require('@/assets/img/icons/menu/' + link.icon + '.svg')"
            :alt="link.name + ' icon'"
          />
          <img
            width="22"
            class="menu-hover"
            :src="
              require('@/assets/img/icons/menu/' + link.icon + '-hover.svg')
            "
            :alt="link.name + ' hover icon'"
          />
        </span>
        <span class="nav-link-text">{{ link.name }}</span>
      </template>
    </a>
    <b-collapse
      :id="link.name.replace(' ', '')"
      v-model="showCollapse"
      v-if="!link.path"
    >
      <div class="w-100">
        <ul class="nav nav-sm flex-column">
          <slot> </slot>
        </ul>
      </div>
    </b-collapse>
    <router-link
      v-else
      class="nav-link"
      :to="link.path"
      :target="link.target"
      :href="link.path"
      @click.native="clickRefresh(link.path)"
    >
      <template>
        <span class="ico-sidebar" v-if="link.icon">
          <img
            width="22"
            class="menu-default"
            :src="require('@/assets/img/icons/menu/' + link.icon + '.svg')"
            :alt="link.name + ' icon'"
          />
          <img
            width="22"
            class="menu-hover"
            :src="
              require('@/assets/img/icons/menu/' + link.icon + '-hover.svg')
            "
            :alt="link.name + ' hover icon'"
          />
        </span>
        <span class="nav-link-text">{{ link.name }}</span>
      </template>
      <span v-if="newModule" class="new-module-label">New</span>
      <span v-if="link.name == 'All contacts'" class="new-link-label ml-3"
        ><img src="@/assets/img/icons/campaign/badge-new.svg" width="65"
      /></span>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info",
    },
    value: {
      defalut: false,
    },
    newModule: {
      defalut: false,
    },
  },
  data() {
    return {
      showCollapse: false,
    };
  },
  watch: {
    value(val) {
      this.showCollapse = val;
    },
    showCollapse(val, oldVal) {
      if (val !== oldVal) {
        this.$emit("input", val);
      }
    },
  },
  computed: {
    automation() {
      return (
        ["Automation", "AdvancedAutomation"].includes(this.$route.name) &&
        this.link.name === "Automations"
      );
    },
  },
  methods: {
    clickRefresh(path) {
      if (this.$router.currentRoute.fullPath === path) {
        this.$store.commit("common/setPageLoad", new Date().getTime());
      }
    },
  },
};
</script>
